import { TLC_CONSTANTS } from "../../../../../js/lib/tlc-constants";
import { TemplateEngine } from "../../../../../js/lib/TemplateEngine";
import { TLCEventManager } from "../../../../../js/lib/events/EventManager";
import { TLCEvents } from "../../../../../js/lib/events/events";
import { TLCLogger } from "../../../../../js/lib/logger";
import { LS2PAC_CONSTANTS } from "../../../../../js/main/constants";
import { DialogManager } from "../../../Managers/DialogManager";
import { HistoryManager } from "../../../Managers/HistoryManager";
import { ApplicationData } from "../../ApplicationData";
import { AvailabilityClientManager } from "../../ClientManagers/AvailabilityClientManager";
import { LoginClientManager } from "../../ClientManagers/LoginClientManager";
import { TeachingBooksClientManager } from "../../ClientManagers/TeachingBooksClientManager";
import { LS2PacSearchDatabaseManager } from "../../managers/SearchDatabaseManager";
import { LS2PAC_Utils } from "../../utils/Utils";
import { LibraryThing } from "../../widget/LibraryThingWidget";
import { BaseView } from "../BaseView";
import { VirtualShelfView } from "../VirtualShelfView";
import * as React from 'react';
import { renderInShadow, renderWithoutShadow } from "@tlc/ls2pac/components/ShadowUtils";
import { RateAndReview } from "@tlc/ls2pac/components/RateAndReview";
import { DetailButtons, RESOURCE_AVAILABILITY_LOADED } from "@tlc/ls2pac/components/DetailButtons";
import { DetailsTabs } from "@tlc/ls2pac/components/DetailsTabs";
import { LocationConfigurationProvider } from "@tlc/ls2pac/components/LocationConfiguration";
import { SyndeticsConfigProvider } from "@tlc/ls2pac/components/SyndeticsConfig";
import { AccountHolder } from "@tlc/ls2pac/components/Account";
import { BackToLink } from "@tlc/ls2pac/components/pages/resource/BackToLink";

export class DetailsContainerView extends BaseView {
  constructor() {
    super({
      targetId: LS2PAC_CONSTANTS.Ids.mainContent,
      id: LS2PAC_CONSTANTS.Ids.DetailsPage.detailsContainer,
    });

    this.currentResource;
    this.backEvent;
    this.addListeners();
    this.resourceData;
    this.currentIndex = 0;
    this.viewName;
    this.isWaitingForResponse = false;
    this.teachingBooksTitleId = null;

    this.virtualShelf = new VirtualShelfView();
  }
  addHistory(event) {
    if (event.fromHistory) {
      return;
    }
    var _this = this;
    var eventCopy = $.extend({}, event);
    if (event.resourceData) {
      eventCopy.resourceData =
        LS2PAC_Utils.getFakePagingDataToSendToFullDetails(
          eventCopy.resources,
          this.currentIndex
        );
    } else {
      eventCopy.resourceData = this.resourceData;
    }
    eventCopy.eventName = LS2PAC_CONSTANTS.Events.onShowFullDetails;
    eventCopy.index = _this.currentIndex;
    eventCopy.viewName =
      eventCopy.viewName || LS2PAC_CONSTANTS.DetailPages.fullDetails;
    HistoryManager.add(
      "section=resource&resourceid=" +
        this.currentResource.id +
        "&currentIndex=" +
        this.currentIndex +
        "&view=" +
        eventCopy.viewName,
      function (eventCopy, hash) {
        _this.viewName = eventCopy.viewName;
        eventCopy.fromHistory = true;
        TLCEventManager.fireEvent(eventCopy.eventName, eventCopy);
      },
      eventCopy
    );
  }
  load(event) {
    this.currentIndex =
      event.index !== undefined ? event.index : this.currentIndex;
    if (event.resourceData) {
      this.resourceData = event.resourceData;
    }
    this.currentResource = this.resourceData.resources[this.currentIndex];

    this.viewName = event.viewName;

    this.addHistory(event);

    this.setHideEvent(this.backEvent);

    var _this = this;
    TemplateEngine.fetch(
      LS2PacSearchDatabaseManager.getCurrentDatabaseConfig()
        .fullDetailsTemplate,
      this.id,
      this.currentResource,
      function (data) {
        _this.addEvents();

        TLCLogger.log(
          "_this.resourceData",
          _this.resourceData,
          _this.currentIndex,
          _this.currentResource,
          _this.viewName
        );

        _this.getExtraData();
      },
      TemplateEngine.method.overwrite
    );
  }
  getExtraData() {
    var _this = this;
    if (_this.resourceData.supportsAvailability) {
      $(
        "#" +
          _this.currentResource.id +
          LS2PAC_CONSTANTS.Ids.DetailsPage.bookJacketSuffix
      ).addCoverArt(
        LibraryThing.enums.requestType.bookJacketMedium,
        _this.resourceData.resources,
        _this.currentIndex,
        true,
        true
      );

      if (parseInt(_this.currentResource.rtype, 10) == 1) {
        const resource = this.currentResource;
        const defaultRating = resource.ratingInformation?.average || 0;
        const container = document.querySelector("#" +
        LS2PAC_CONSTANTS.Ids.DetailsPage.ratingsSuffix + _this.currentResource.id );

					renderInShadow(
            <RateAndReview
              name="rating"
              resourceId={resource.id}
              averageRating={defaultRating}
            ></RateAndReview>,

            container,
            ApplicationData.language
          );
      }
      renderWithoutShadow(<BackToLink></BackToLink>, document.querySelector(".detailsTop"), ApplicationData.language);
      renderWithoutShadow(
        <LocationConfigurationProvider>
          <SyndeticsConfigProvider>
            <DetailsTabs
              resourceData={this.currentResource}
            ></DetailsTabs>
          </SyndeticsConfigProvider>
        </LocationConfigurationProvider>,
        document.getElementById(
          LS2PAC_CONSTANTS.Ids.DetailsPage.detailsPageNavigation
        ),
        ApplicationData.language
      );

      renderInShadow(
        <DetailButtons
          resource={this.currentResource}
          isVirtualShelfEnabled={ApplicationData.locationConfiguration.isVirtualShelfEnabled()} 
          onClickAddToList={(event) => {
            TLCEventManager.fireEvent(LS2PAC_CONSTANTS.Events.onOpenAddToList, {
              element: $(event.currentTarget),
              resourceIds: [this.currentResource.id],
            });
          }}
          onClickVirtualShelf={(event) => {
            TLCEvents.trigger(LS2PAC_CONSTANTS.Events.onShowVirtualShelf, {
              resource: this.currentResource,
            });
          }}
          onClickCheckoutDownloadable={(event) => {
            TLCEventManager.fireEvent(
              LS2PAC_CONSTANTS.Events.onAttemptEResourceCheckout,
              {
                resource: this.currentResource,
                referrer: "Details",
              }
            );
          }}
          onClickPlaceRequest={(event) => {
            TLCEventManager.fireEvent(LS2PAC_CONSTANTS.Events.onRequest, {
              resource: this.currentResource,
              referrer: "Details",
            });
          }}
        />,
        document.getElementById("detailButtonsContainer"),
        ApplicationData.language
      );

      if (ApplicationData.locationConfiguration.isTeachingBooksEnabled()) {
        TeachingBooksClientManager.getTeachingBooksTitleId(
          _this.currentResource,
          function (titleId) {
            if (titleId) {
              _this.teachingBooksTitleId = titleId;
              $(
                "#" +
                  _this.currentResource.id +
                  LS2PAC_CONSTANTS.Ids.DetailsPage.teachingBooksLink
              ).show();
            }
          }
        );
      }

      AvailabilityClientManager.getItemAvailability(
        [_this.currentResource],
        function (resources, wentToServer, success) {
          if (success) {
            _this.setViews();
            _this.setRequestButton();
          }
        }
      );

    } else {
      _this.setViews();
    }
  }
  setRequestButton() {
    LS2PAC_Utils.getAvailabilityDisplayObject(this.currentResource);
    TLCEventManager.fireEvent(RESOURCE_AVAILABILITY_LOADED, {
      resource: this.currentResource
    });
    // if (this.currentResource.showRequestButton) {
      // var requetButtonLoc = $(
      //   "#" + LS2PAC_CONSTANTS.Ids.DetailsPage.detailsListAndRequestControls
      // );
      // requetButtonLoc.find("li .request, li .external, li .eResource").remove();
      // this.requestButtonExt.prepend(requetButtonLoc, {
      //   index: this.currentIndex,
      //   resource: this.currentResource,
      // });
    // }
  }
  setViews() {
    var _this = this;
    var viewToSend = _this.viewName;
    if (parseInt(_this.currentResource.rtype, 10) != 1) {
      viewToSend = undefined;
    }

    $.each(_this.resourceData.detailViews, function (index, viewData) {
      viewData.view.setData(
        _this.resourceData,
        _this.currentIndex,
        viewToSend,
        _this
      );
    });
  }
  handlePagingEvent(direction) {
    this.disablePagingControls();
    this.currentIndex += direction;
    if (direction > 0) {
      if (this.currentIndex == this.resourceData.resources.length) {
        this.currentIndex = 0;
        this.isWaitingForResponse = true;
        TLCEventManager.fireEvent(
          TLC_CONSTANTS.Events.onClickSkipToResultPage,
          { pageNum: this.resourceData.currentPage + 1 }
        );
      } else {
        this.showFullDetails();
      }
    }

    if (direction < 0) {
      if (this.currentIndex < 0) {
        this.currentIndex = this.resourceData.resources.length - 1;
        this.isWaitingForResponse = true;
        TLCEventManager.fireEvent(
          TLC_CONSTANTS.Events.onClickSkipToResultPage,
          { pageNum: this.resourceData.currentPage - 1 }
        );
      } else {
        this.showFullDetails();
      }
    }
  }
  showFullDetails() {
    this.hideTagForm();
    TLCEventManager.fireEvent(LS2PAC_CONSTANTS.Events.onShowFullDetails, {
      index: this.currentIndex,
      viewName: this.viewName,
    });
  }
  showTagForm() {
    $("#" + LS2PAC_CONSTANTS.Ids.DetailsPage.newTagText).val("");
    $("#" + LS2PAC_CONSTANTS.Ids.DetailsPage.addNewTagForm).slideDown(
      400,
      function () {
        $("#" + LS2PAC_CONSTANTS.Ids.DetailsPage.newTagText).trigger("focus");
      }
    );
  }
  hideTagForm(callback) {
    callback = callback || function () {};
    $("#" + LS2PAC_CONSTANTS.Ids.DetailsPage.addNewTagForm).slideUp(
      400,
      callback
    );
    //$("#"+this.id).find(".addNewTag").removeClass("disabled");
  }
  updatePagingControls() {
    if (this.resourceData.currentPage == 1 && this.currentIndex == 0) {
      $("#" + this.id)
        .find(".prev")
        .each(function (index, link) {
          $(link).addClass(LS2PAC_CONSTANTS.CssClasses.disabled);
        });
    } else {
      $("#" + this.id)
        .find(".prev")
        .each(function (index, link) {
          $(link).removeClass(LS2PAC_CONSTANTS.CssClasses.disabled);
        });
    }
    if (
      this.resourceData.currentPage == this.resourceData.totalPages &&
      this.currentIndex == this.resourceData.resources.length - 1
    ) {
      $("#" + this.id)
        .find(".next")
        .each(function (index, link) {
          $(link).addClass(LS2PAC_CONSTANTS.CssClasses.disabled);
        });
    } else {
      $("#" + this.id)
        .find(".next")
        .each(function (index, link) {
          $(link).removeClass(LS2PAC_CONSTANTS.CssClasses.disabled);
        });
    }
  }
  disablePagingControls() {
    $("#" + this.id)
      .find(".prev, .next")
      .each(function (index, link) {
        $(link).addClass(LS2PAC_CONSTANTS.CssClasses.disabled);
      });
  }
  addEvents() {
    if (this.hasBoundEvents === false) {

      $("#" + this.id).on("click", ".teachingBooksLink", (event) => {
        TLCEvents.trigger(LS2PAC_CONSTANTS.Events.onTeachingBooksButtonClick, {
          tid: this.teachingBooksTitleId,
          callbackFunc: (teachingBooksData) => {
            $("#" + this.currentResource.id + "_teachingBooksForm").attr(
              "action",
              teachingBooksData.link
            );
            $(
              "#" +
                this.currentResource.id +
                "_teachingBooksForm input[name=oauth_callback]"
            ).val(teachingBooksData.oauthCallback);
            $(
              "#" +
                this.currentResource.id +
                "_teachingBooksForm input[name=oauth_consumer_key]"
            ).val(teachingBooksData.oauthConsumerKey);
            $(
              "#" +
                this.currentResource.id +
                "_teachingBooksForm input[name=oauth_nonce]"
            ).val(teachingBooksData.oauthNOnce);
            $(
              "#" +
                this.currentResource.id +
                "_teachingBooksForm input[name=oauth_signature]"
            ).val(teachingBooksData.oauthSignature);
            $(
              "#" +
                this.currentResource.id +
                "_teachingBooksForm input[name=oauth_signature_method]"
            ).val(teachingBooksData.oauthSignatureMethod);
            $(
              "#" +
                this.currentResource.id +
                "_teachingBooksForm input[name=oauth_timestamp]"
            ).val(teachingBooksData.oauthTimestamp);
            $(
              "#" +
                this.currentResource.id +
                "_teachingBooksForm input[name=oauth_version]"
            ).val(teachingBooksData.oauthVersion);
            $(
              "#" +
                this.currentResource.id +
                "_teachingBooksForm input[name=lti_version]"
            ).val(teachingBooksData.ltiVersion);
            $(
              "#" +
                this.currentResource.id +
                "_teachingBooksForm input[name=lti_message_type]"
            ).val(teachingBooksData.ltiMessageType);
            $("#" + this.currentResource.id + "_teachingBooksForm").trigger("submit");
          },
        });
        return false;
      });

      $("#" + this.id).on("click", ".prev", (event) => {
        this.handlePagingEvent(-1);
        return false;
      });

      $("#" + this.id).on("click", ".next", (event) => {
        this.handlePagingEvent(1);
        return false;
      });

      $("#" + this.id).on("click", ".addNewTag", (event) => {
        LoginClientManager.promptIfNotLoggedIn(() => {
          this.showTagForm();
        });
        return false;
      });

      $("#" + this.id).on("click", ".deleteTag", (event) => {
        TLCEvents.trigger(LS2PAC_CONSTANTS.Events.onDeleteTag, {
          resource: this.currentResource,
          tagId: $(event.currentTarget).data("tagid"),
        });
        return false;
      });

      $("#" + this.id).on("click", ".allCopies", (event) => {
        TLCEventManager.fireEvent(
          LS2PAC_CONSTANTS.Events.onShowFullDetailsSubView,
          { viewName: LS2PAC_CONSTANTS.DetailPages.allCopies }
        );
        return false;
      });

      $("#" + this.id).on("click", ".searchLink", (event) => {
        LS2PacSearchDatabaseManager.setCurrentDatabaseKey(
          LS2PAC_CONSTANTS.Ids.SearchPage.Tabs.ls2pac.key
        );
        const ele = $(event.currentTarget),
          searchString = ele.attr("data-value"),
          type = ele.attr("data-type");

        TLCEventManager.fireEvent(LS2PAC_CONSTANTS.Events.onSearch, {
          searchString: searchString,
          searchType: type,
        });
        return false;
      });

      $("#" + this.id).on(
        "submit",
        "#" + LS2PAC_CONSTANTS.Ids.DetailsPage.addNewTagForm + " form",
        (event) => {
          const tag = $("#" + LS2PAC_CONSTANTS.Ids.DetailsPage.newTagText).val();

          TLCEventManager.fireEvent(LS2PAC_CONSTANTS.Events.onAddTag, {
            tag: tag,
            userEntered: true,
            resource: this.currentResource,
          });
          $("#" + LS2PAC_CONSTANTS.Ids.DetailsPage.newTagText).trigger("blur");
          return false;
        }
      );


      this.hasBoundEvents = true;
    }
  }
  removeEvents() {
    $("#" + this.id).off("click", ".teachingBooksLink");
    $("#" + this.id).off("click", ".prev");
    $("#" + this.id).off("click", ".next");
    $("#" + this.id).off("click", ".addNewTag");
    $("#" + this.id).off("click", ".deleteTag");
    $("#" + this.id).off("click", ".allCopies");
    $("#" + this.id).off("click", ".searchLink");
    $("#" + this.id).off(
      "submit",
      "#" + LS2PAC_CONSTANTS.Ids.DetailsPage.addNewTagForm + " form"
    );
  }
  addListeners() {

    // removal of these events is handled by the base class cleanup
    this.setHideEvent(LS2PAC_CONSTANTS.Events.onSearch);
    this.setHideEvent(LS2PAC_CONSTANTS.Events.onMyAccount);
    this.setHideEvent(LS2PAC_CONSTANTS.Events.onChangeBranchLimits);
    this.setHideEvent(LS2PAC_CONSTANTS.Events.onAdvancedSearch);
    this.setHideEvent(LS2PAC_CONSTANTS.Events.onLogoutResponse);
    this.setHideEvent(LS2PAC_CONSTANTS.Events.onHome);
    this.setShowEvent(LS2PAC_CONSTANTS.Events.onShowFullDetails);
    this.setHideEvent(LS2PAC_CONSTANTS.Events.onObrShowForm);

    var _this = this;

    this.addListener(LS2PAC_CONSTANTS.Events.onViewNullResource, function (event) {
      DialogManager.show({
        content: ApplicationData.language.invalidResourceIdDeepLinkMessage,
        dialogTitle: ApplicationData.language.errorDialogTitle,
        okText: ApplicationData.language.ok,
        showCancel: false,
      });
    })

    this.addListener(TLC_CONSTANTS.Events.onPagingModelResponse, function (event) {
      if (event.success) {
        _this.resourceData = event.data;
        if (_this.isWaitingForResponse) {
          _this.showFullDetails();
          _this.isWaitingForResponse = false;
        }
      }
    })

    this.addListener(LS2PAC_CONSTANTS.Events.onShowFullDetailsSubView, function (event) {
      LS2PAC_CONSTANTS.Events.onShowFullDetailsSubView,
      _this.viewName = event.viewName;
      _this.addHistory(event);
      _this.setViews();
    })



    this.addListener(
      LS2PAC_CONSTANTS.Events.onLogoutResponse,
      function (event) {
        if (event.success) {
          _this.hideTagForm();
        }
      }
    );

    this.addListener(
      LS2PAC_CONSTANTS.Events.onAddTagResponse,
      function (event) {
        if (event.success) {
          _this.hideTagForm();
          if (event.tag !== null) {
            var classSuffix = AccountHolder.isConfigAdmin
              ? "_admin"
              : "";
            $("#" + LS2PAC_CONSTANTS.Ids.DetailsPage.addNewTagForm).after(
              '<div class="tagDiv" data-tagid="' +
                event.tag.id +
                '" style="display: none"><div class="deletableTagLeft' +
                classSuffix +
                '"><a href="javascript:void(0);" class="tag">' +
                event.tag.data +
                '</a></div><div class="deletableTagRight' +
                classSuffix +
                '"><a href="javascript:void(0);" data-tagid="' +
                event.tag.id +
                '" class="deleteTag">x</a></div><div class="deletableTagSpacer' +
                classSuffix +
                '"></div></div>'
            );
            $(
              $("#" + LS2PAC_CONSTANTS.Ids.DetailsPage.details_tags).find(
                "div:eq(1)"
              )
            ).slideDown();
          }
        } else {
          _this.hideTagForm();
        }
      }
    );

    this.addListener(
      LS2PAC_CONSTANTS.Events.onDeleteTagResponse,
      function (event) {
        $(".tagDiv[data-tagid='" + event.tagId + "']").remove();
      }
    );
  }

  cleanup(){
    super.cleanup();
  }
}

DetailsContainerView.prototype.render = DetailsContainerView.prototype.load;
